module.exports = __webpack_public_path__ + "img/truck-ramp-couch.2c6cb283.svg";